<template>
    <v-container
      class="fill-height py-0"
      fluid
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="4"
          class="pa-0"
        >
          <v-img usemap="" class="image hotspot" contain :src="image" max-width="100%" id="hotspot">
              <a style="position:absolute; top: 55%; left: 86%; height: 4%; width: 8%;" @click.prevent="goToCode"></a>
              <img :src="logo" class="overlay-logo" />
          </v-img>
          <v-card class="elevation-0 login--card" color="rgba(0, 0, 0, 0)">
            <v-toolbar
              color="rgba(0, 0, 0, 0)"
              dark
              flat
              class="title--toolbar"
            >
              <v-spacer></v-spacer>
              <v-toolbar-title class="display-1 text-uppercase font-weight-black sub--title login--title">Enter Login</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text class="login--fieldbg">
              <ValidationObserver ref="observer">
                <v-form class="mt-2 mb-2">
                  <ValidationProvider v-slot="{ errors }" name="Email Address" rules="required|email">
                    <v-text-field
                      label="Email Address"
                      name="login"
                      type="text"
                      v-model="form.email"
                      dark
                      :error-messages="errors"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ errors }" name="Password" rules="required">
                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    type="password"
                    v-model="form.password"
                    dark
                    :error-messages="errors"
                    required
                  ></v-text-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions class="px-0">
              <v-spacer></v-spacer>
              <v-btn x-large min-width="248" light color="#ffffff" class="mb-4 access--btn" @click.prevent="submit">Log In</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
    import { mapActions } from 'vuex'
    import { required, email } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import image from "@/assets/portrait.jpg"
    import logo from "@/assets/logo.png"

    setInteractionMode('eager')

    extend('required', {
      ...required,
      message: '{_field_} can not be empty',
    })

    extend('email', {
      ...email,
      message: 'Email must be valid',
    })

    export default {
        props: {
        source: String,
        },
        data: () => ({
            form: {
                email: '',
                password: ''
            },
            loading: false,
            image: image,
            logo: logo
        }),
        components: {
          ValidationProvider,
          ValidationObserver,
        },
        methods: {
            ...mapActions({
              signIn: 'auth/signIn'
            }),
            async submit() {              
              let valid = await this.$refs.observer.validate()

              if(valid) {
                this.loading = true
                this.signIn(this.form).then(() => {
                    this.$router.replace({
                      name: 'Dashboard'
                    })
                }).catch(() => {
                  this.loading = false
                  this.$store.commit('SET_SNACKTYPE', 'red')
                  this.$store.commit('SET_SNACK', 'Login Failed! Please try again.')
                })
              }
            },
            goToCode() {
              this.$store.commit('menu/SET_TRANSITION', true)
              setTimeout( ()=> {
                this.$router.push({path: "/code"})
              }, 1000)
            },
        }
    }
</script>

<style lang="sass">   
img
  &.overlay-logo 
    position: absolute
    top: 24%
    width: 250px
    left: 50%
    transform: translate(-50%)

main
  &.v-content
    &.Home 
      background: #0655b8

.transitionBG 
  position: fixed
  top: 0
  left: 0
  height: 100%
  width: 100%
  background: #000
  z-index: 9999999999
  
.login--card
  position: absolute
  top: 38%
  left: 50%
  width: 70%
  transform: translateX(-50%)
  max-width: 300px

.login--fieldbg 
  background: rgb(0, 57, 110)
  border-radius: 5px

button
  &.access--btn
    font-size: 30px!important
    color: #00396e!important
    letter-spacing: 0
    margin-top: 10px
    font-family: 'Pyxel'!important

.v-toolbar__title
  &.display-1
    &.text-uppercase
      &.font-weight-black
        &.sub--title 
          &.login--title
            font-size: 36px!important
            line-height: 1em!important
            letter-spacing: 0!important
            font-family: Pyxel!important
            margin-bottom: 15px!important

.title--toolbar 
  .v-toolbar__content 
    padding-left: 0
    padding-right: 0
</style>